import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import RadialProgressBar from '@/_core/shared/ui/RadialProgressBar/RadialProgressBar.vue';
import { TReport } from '../../models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportVulnerabilityStats',
  props: {
    reportData: null
  },
  setup(__props: any) {

const props = __props as { reportData: TReport };

const SEVERITY_CARDS = [
  {
    variant: 'high' as const,
    title: 'High priority',
    description: 'Can result in data leaks and privacy violation',
  },
  {
    variant: 'medium' as const,
    title: 'Recommend to fix',
    description: 'May reduce app security',
  },
  {
    variant: 'low' as const,
    title: 'Nice to have',
    description: 'Violate best practices',
  },
];



const stats = props.reportData.statistics;
const total = stats.percentageBySeverity.commonAmountVulnerabilities;

const severityCounts = computed(() =>
  stats.percentageBySeverity.commonAmountVulnerabilitiesBySeverity.reduce(
    (prev, { severity, count }) => {
      prev[severity] = count;
      return prev;
    },
    { low: 0, medium: 0, high: 0, critical: 0 } as Record<string, number>
  )
);

return { __sfc: true,SEVERITY_CARDS, props, stats, total, severityCounts, RadialProgressBar }
}

})